/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputGeoTraceWarning
 */
export interface OutputGeoTraceWarning {
    /**
     * skipped_exact_match | chosen_far_from_core
     * @type {string}
     * @memberof OutputGeoTraceWarning
     */
    code?: string;
    /**
     * Detail — назва НП з газетира, через яку виникло попередження.
     * @type {string}
     * @memberof OutputGeoTraceWarning
     */
    detail?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputGeoTraceWarning
     */
    text?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceWarning
     */
    tokenIndex?: number;
}

/**
 * Check if a given object implements the OutputGeoTraceWarning interface.
 */
export function instanceOfOutputGeoTraceWarning(value: object): boolean {
    return true;
}

export function OutputGeoTraceWarningFromJSON(json: any): OutputGeoTraceWarning {
    return OutputGeoTraceWarningFromJSONTyped(json, false);
}

export function OutputGeoTraceWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoTraceWarning {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'detail': json['detail'] == null ? undefined : json['detail'],
        'text': json['text'] == null ? undefined : json['text'],
        'tokenIndex': json['tokenIndex'] == null ? undefined : json['tokenIndex'],
    };
}

export function OutputGeoTraceWarningToJSON(value?: OutputGeoTraceWarning | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'detail': value['detail'],
        'text': value['text'],
        'tokenIndex': value['tokenIndex'],
    };
}

